import { createSlice } from '@reduxjs/toolkit';
import { GetMyTeamMemberInvites } from './get-my-team-member-invites.thunk';
import { TeamMemberInvitesState } from './team-member-invites.state';

const initialState: TeamMemberInvitesState = {
    canInvite: false,
    teams: [],
    members: [],
    isLoading: false,
    isLoaded: false,
};

const teamMemberInvitesSlice = createSlice({
    name: 'teamMemberInvites',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(GetMyTeamMemberInvites.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(GetMyTeamMemberInvites.fulfilled, (state, action) => {
                state.canInvite = action.payload.canInvite;
                state.teams = action.payload.teams ?? [];
                state.members = action.payload.members ?? [];
                state.isLoading = false;
                state.isLoaded = true;
            })
            .addCase(GetMyTeamMemberInvites.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export default teamMemberInvitesSlice.reducer;
